import React, { Component } from 'react';
import { connect } from 'dva';
import moment from 'moment';
import { Tooltip, Col, Row, Input, Form, Button, DatePicker, Modal, Popconfirm, message } from 'antd';
// import router from 'umi/router';
import SelectUser from 'nbugs-select-user-result-v4.0';
import ListPage from '../../../../../components/ListPage';
import Container from '../../../../../components/Container';
import {
  kindergartenClass,
  primarySchoolClass,
  middleSchoolClass,
} from '../../CourseManage/utils/classData';
import { getAppCode } from '../../utils/utils';
import styles from './index.less';

const { ListTable } = ListPage;
const { RangePicker } = DatePicker;

const statusText = {
  1: '自动推送',
  2: '审批推送',
  3: '补发推送',
};

const naozhongIcon = 'https://s.xiaoyuanhao.com/file/0667e1a2-9dc4-4e0e-91be-4847d7b23ddd.png'

@connect()
class Pushrecord extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: [],
      dataSource: [],
      loading: false,
      totalElements: 0,
      params: {
        appCode: getAppCode(),
        page: 1,
        pageSize: 10,
        title: '',
        start_time: '',
        end_time: '',
      },

      isModalVisible: false,
      selectUserModalData: [],
      recipientUserids: '',
    };
  }

  componentDidMount() {
    const { params } = this.state;
    this.setColumns();
    this.fetchPushRecord(params);
  }

  search = e => {
    e.preventDefault();
    const { form } = this.props;
    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const { params } = this.state;
        const rangeValue = values['range-picker'];
        const tempParams = {
          ...params,
          title: values.title ? encodeURIComponent(values.title) : '',
          start_time: rangeValue && rangeValue[0] ? rangeValue[0].format('YYYYMMDD') : '',
          end_time: rangeValue && rangeValue[1] ? rangeValue[1].format('YYYYMMDD') : '',
          page: 1,
        };
        this.setState({
          params: tempParams,
        });
        this.fetchPushRecord(tempParams);
      }
    });
  };

  reSet = () => {
    const { form } = this.props;
    form.resetFields();
    const { params } = this.state;
    const tempParams = {
      ...params,
      title: '',
      start_time: '',
      end_timg: '',
      page: 1,
    };
    this.setState({
      params: tempParams,
    });
    this.fetchPushRecord(tempParams);
  };

  fetchPushRecord = params => {
    const { dispatch } = this.props;
    this.setState({ loading: true });
    dispatch({
      type: 'push/fetchPushRecord',
      params,
    })
      .then(res => {
        this.setState({
          loading: false,
          dataSource: res.content,
          totalElements: res.totalElements,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  showRecipientUser = (data, recipientUserids) => {
    this.setState({
      isModalVisible: true,
      selectUserModalData: data,
      recipientUserids,
    });
  };

  confirmCancleTimeSend = id => {
    const { dispatch } = this.props;
    const { params } = this.state;
    this.setState({ loading: true });
    dispatch({
      type: 'push/fetchCancelPush',
      params: {
        id,
        appCode: getAppCode(),
      },
    })
      .then(() => {
        this.fetchPushRecord(params);
        message.success('操作成功');
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  }

  setColumns = () => {
    const columns = [
      {
        title: '标题',
        dataIndex: 'title',
        key: 'title',
        width: 400,
        render: (text, record) => {
          const { isTiming } = record;
          if (text.length <= 20) {
            return <span className='title'>{Number(isTiming) === 1 && <img src={naozhongIcon} alt='' />}{text}</span>;
          }
          return (
            <Tooltip placement="top" title={text}>
              <span className='title'>{Number(isTiming) === 1 && <img src={naozhongIcon} alt='' />}{text.substring(0, 20)}...</span>
            </Tooltip>
          );
        },
      },
      {
        title: '类型',
        dataIndex: 'pushType',
        key: 'pushType',
        render: text => {
          return <span>{statusText[text]}</span>;
        },
      },
      {
        title: '推送对象',
        dataIndex: 'recipient',
        key: 'recipient',
        render: (text, record) => {
          const { recipientUserids, newsPushSelectIds = [], recipient } = record;
          if (recipientUserids === 'selectId' || recipientUserids === 'gradeType') {
            return (
              <div
                style={{ color: '#1785EC' }}
                onClick={() =>
                  this.showRecipientUser(
                    recipientUserids === 'selectId' ? newsPushSelectIds : JSON.parse(recipient),
                    recipientUserids
                  )
                }
              >
                查看
              </div>
            );
          }
          return <span>{text}</span>;
        },
      },
      {
        title: '操作人',
        dataIndex: 'pushUser',
        key: 'pushUser',
        render: (text, record) => {
          return <span>{record.pushType === '3' ? text : '-'}</span>;
        },
      },
      {
        title: '推送时间',
        dataIndex: 'pushTime',
        key: 'pushTime',
        width: 160,
        render: text => {
          return text ? <span>{moment(text).format('YYYY.MM.DD HH:mm')}</span> : <span> - </span>;
        },
      },
      {
        title: '状态',
        dataIndex: 'pushresult',
        key: 'pushresult',
      },
      {
        title: '操作',
        dataIndex: 'isTiming',
        key: 'isTiming',
        width: 150,
        fixed: 'right',
        render: (data, record) => {
          return (
            <>
              {
                Number(data) === 1 ? (
                  <Popconfirm
                    title="你确定取消定时推送吗？"
                    onConfirm={e => {
                      e.stopPropagation();
                      this.confirmCancleTimeSend(record.id)
                    }}
                    onCancel={e => e.stopPropagation()}
                  >
                    <div
                      style={{ color: '#1785EC' }}
                      onClick={e => {
                        e.stopPropagation()
                      }}
                    >
                      取消定时推送
                    </div>
                  </Popconfirm>
                ) : '-'
              }
            </>

          )
        },
      },
    ];
    this.setState({ columns });
  };

  changePage = (page, pageSize) => {
    const { params } = this.state;
    const tempParams = {
      ...params,
      page,
      pageSize,
    };
    this.setState({ params: tempParams });
    this.fetchPushRecord(tempParams);
  };

  studentList = student => {
    const allData = kindergartenClass.concat(primarySchoolClass).concat(middleSchoolClass);
    const data = [];
    allData.forEach(item => {
      student.forEach(id => {
        if (id === item.key) {
          data.push(item.name);
        }
      });
    });

    return data.join('、');
  };

  render() {
    const {
      columns,
      loading,
      dataSource,
      params,
      totalElements,
      isModalVisible,
      selectUserModalData,
      recipientUserids,
    } = this.state;
    const { page } = params;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
    };
    const { form } = this.props;
    const { getFieldDecorator } = form;
    const pageProps = {
      spinProps: { spinning: loading },
      className: styles.root,
    };

    const tableProps = {
      pageInfo: { totalElements, page },
      columns,
      list: dataSource,
      rowKey: 'id',
      onPageChange: this.changePage,
    };

    return (
      <Container breStates isSplitBar>
        <ListPage {...pageProps}>
          <Row className={styles['search-area']}>
            <Col span={10}>
              <Form.Item {...formItemLayout} label="文章标题">
                {getFieldDecorator('title', {
                  rules: [
                    {
                      max: 50,
                      message: '请勿超过50个字!',
                    },
                  ],
                })(<Input placeholder="请输入标题" onPressEnter={this.search} />)}
              </Form.Item>
            </Col>
            <Col span={10}>
              <Form.Item label="时间" {...formItemLayout}>
                {getFieldDecorator(
                  `range-picker`,
                  {}
                )(<RangePicker format="YYYY-MM-DD" placeholder={['请选择', '请选择']} />)}
              </Form.Item>
            </Col>
            <Col offset={16} className="search-button">
              <Form.Item>
                <Button type="primary" onClick={this.search}>
                  查询
                </Button>
                <Button onClick={this.reSet}>重置</Button>
              </Form.Item>
            </Col>
          </Row>
          <section className="table-area">
            <ListTable {...tableProps} />
          </section>
        </ListPage>
        {isModalVisible && (
          <Modal
            title="查看推送对象"
            centered
            wrapClassName="select-user-result-v4-modal"
            visible={isModalVisible}
            onOk={() => {
              this.setState({
                isModalVisible: false,
                selectUserModalData: [],
                recipientUserids: '',
              });
            }}
            onCancel={() => {
              this.setState({
                isModalVisible: false,
                selectUserModalData: [],
                recipientUserids: '',
              });
            }}
          >
            <div>
              {selectUserModalData.map(item => {
                const selectUserProps = {
                  multiple: true,
                  selectType: 'dept',
                  strictOrgRel: true,
                  showTabList: ['orgRel'],
                  selectSignature:
                    recipientUserids === 'gradeType' ? item.selectDO.selectId : item.selectId,
                  isSaveSelectSignature: true,
                  requestParams: {
                    strictUser: true,
                    selectTypeList: ['org_rel'],
                  },
                  resultTitle: '发布对象',
                };
                return (
                  <div
                    className={`select-user-result-v4-content ${recipientUserids === 'gradeType' ? 'gradeType' : ''
                      }`}
                  >
                    <div className="article-title">
                      <span className="line"></span>
                      {item.title}
                    </div>
                    <SelectUser key={new Date()} selectUserProps={selectUserProps} />
                    {recipientUserids === 'gradeType' && (
                      <div className="selece-people">
                        {item.selectDO.isStudent === 1 && (
                          <div>
                            学生：
                            <span>{this.studentList(item.selectDO.student.split(','))}</span>
                          </div>
                        )}
                        {item.selectDO.isEmployee === 1 && <div>教职工</div>}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </Modal>
        )}
      </Container>
    );
  }
}

const PushRecord = Form.create()(Pushrecord);
export default PushRecord;
